import { Component } from '@angular/core';
import { Input } from '@angular/core';
export class TdLayoutCardOverComponent {
/**
 * cardTitle?: string
 * 
 * Title set in card.
 */
cardTitle: string;
/**
 * cardSubtitle?: string
 * 
 * Subtitle set in card.
 */
cardSubtitle: string;
/**
 * cardWidth?: string
 * 
 * Card flex width in %.
 * Defaults to 70%.
 */
cardWidth: number = 70;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, primary is used.
 */
color: string = 'primary';

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-layout-card-over',
  styleUrls: ['./layout-card-over.component.css' ],
  templateUrl: './layout-card-over.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cardTitle': [{ type: Input, args: ['cardTitle', ] },],
'cardSubtitle': [{ type: Input, args: ['cardSubtitle', ] },],
'cardWidth': [{ type: Input, args: ['cardWidth', ] },],
'color': [{ type: Input, args: ['color', ] },],
};
}

function TdLayoutCardOverComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdLayoutCardOverComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdLayoutCardOverComponent.ctorParameters;
/** @type {?} */
TdLayoutCardOverComponent.propDecorators;
/**
 * cardTitle?: string
 * 
 * Title set in card.
 * @type {?}
 */
TdLayoutCardOverComponent.prototype.cardTitle;
/**
 * cardSubtitle?: string
 * 
 * Subtitle set in card.
 * @type {?}
 */
TdLayoutCardOverComponent.prototype.cardSubtitle;
/**
 * cardWidth?: string
 * 
 * Card flex width in %.
 * Defaults to 70%.
 * @type {?}
 */
TdLayoutCardOverComponent.prototype.cardWidth;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, primary is used.
 * @type {?}
 */
TdLayoutCardOverComponent.prototype.color;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
